/* A simple KVP section of the store (state.rdx) */
import moment from "moment";
import Context from "../context/Context";

let nextId = 0;

export default class Rdx {

  static store;

  static Keys = {
    SIDEBAR_ACTIVE_KEY: "SIDEBAR_ACTIVE_KEY",
    SIDEBAR_PANELS_EXPANDED: "SIDEBAR_PANELS_EXPANDED",
    INFOPANEL_ACTIVE_KEY: "INFOPANEL_ACTIVE_KEY",
    INFOPANEL_OPEN: "INFOPANEL_OPEN",
    EVENTS_DATEFILTER_OPTION: "EVENTS_DATEFILTER_OPTION",
    EVENTS_DATEFILTER_DATESELECTED: "EVENTS_DATEFILTER_DATESELECTED",
    EVENTS_TIMEFILTER_OPTION: "EVENTS_TIMEFILTER_OPTION",
    EVENTS_TYPEFILTER_OPTION: "EVENTS_TYPEFILTER_OPTION",
    EVENTS_TYPEFILTER_OPTIONS: "EVENTS_TYPEFILTER_OPTIONS",

    BOOK_DATEFILTER_STARTSELECTED: "BOOK_DATEFILTER_STARTSELECTED",
    BOOK_DATEFILTER_ENDSELECTED: "BOOK_DATEFILTER_ENDSELECTED",
    BOOK_TIMEFILTER_STARTSELECTED: "BOOK_TIMEFILTER_STARTSELECTED",
    BOOK_TIMEFILTER_ENDSELECTED: "BOOK_TIMEFILTER_ENDSELECTED",
    BOOK_ALLDAY: "BOOK_ALLDAY",
    BOOK_CHECKIN: "BOOK_CHECKIN",
    BOOK_CHECKOUT: "BOOK_CHECKOUT",

    SITE_FILTERS: "SITE_FILTERS",
    SITE_DROPDOWN: "SITE_DROPDOWN",
    SPACETYPES_DROPDOWN: "SPACETYPES_DROPDOWN",
    SPACETYPE_FILTERS: "SPACETYPE_FILTERS",
    AREA_FILTERS: "AREA_FILTERS",
    DEFAULT_AREA: "DEFAULT_AREA",
    BOOK_FILTERED_RESULTS: "BOOK_FILTERED_RESULTS",
    BOOK_FILTERED_RESULTS_NO_EMAIL: "BOOK_FILTERED_RESULTS_NO_EMAIL",
    BOOK_SORT_SORTBY: "SORT_SORTBY",
    BOOK_SORT_SORTDIR: "SORT_SORTDIR",
    BOOK_WAS_SORT_INIT: "BOOK_WAS_SORT_INIT",

    ACTIVE_HOTDESK_AREA_ID: "ACTIVE_HOTDESK_AREA_ID",
    ACTIVE_HOTEL_AREA_ID: "ACTIVE_HOTEL_AREA_ID",

    PLAN_CAN_REDO: "PLAN_CAN_REDO",
    PLAN_CAN_UNDO: "PLAN_CAN_UNDO",

    SPACEPLANNER_ACTIVE_SECTION: "SPACEPLANNER_ACTIVE_SECTION",
    COMMENTS_ACTIVE_PIN: "COMMENTS_ACTIVE_PIN"
  };

  static Types = {
    RESET_ALL: "RESET_ALL",
    SET_VALUE: "SET_VALUE"
  };

  static Actions = {

    resetAll: (key,value) => ({
      type: Rdx.Types.RESET_ALL
    }),

    setValue: (key,value) => ({
      type: Rdx.Types.SET_VALUE,
      payload: {key: key, value: value}
    })

  };

  static Selectors = {

    getValue: (state,section,key) => {
      if (state[section]) return state[section][key];
    }

  }

  static Reducers = {

    rdx: (state = {}, action) => {
      let newState;
      switch (action.type) {
        case Rdx.Types.RESET_ALL:
          newState = Object.assign({}, Rdx.getInitialState().rdx);
          Object.keys(state).forEach(k => {
            if (k && k.indexOf("cfg-") === 0) {
              newState[k] = state[k];
            }
          });
          return newState;
        case Rdx.Types.SET_VALUE:
          newState = Object.assign({}, state);
          newState[action.payload.key] = action.payload.value;
          return newState;
        default:
          return state
      }
    }

  }

  static getInitialState() {
    const initialState = {
      rdx: {}
    };

    initialState.rdx[Rdx.Keys.EVENTS_DATEFILTER_OPTION] = "today";
    initialState.rdx[Rdx.Keys.BOOK_DATEFILTER_STARTSELECTED] = new Date();
    initialState.rdx[Rdx.Keys.BOOK_DATEFILTER_ENDSELECTED] = new Date();
    initialState.rdx[Rdx.Keys.BOOK_TIMEFILTER_STARTSELECTED] = null;
    initialState.rdx[Rdx.Keys.BOOK_TIMEFILTER_ENDSELECTED] = null;
    initialState.rdx[Rdx.Keys.BOOK_ALLDAY] = true;
    initialState.rdx[Rdx.Keys.BOOK_CHECKIN] = null;
    initialState.rdx[Rdx.Keys.BOOK_CHECKOUT] = null;
    initialState.rdx[Rdx.Keys.SITE_FILTERS] = null;
    initialState.rdx[Rdx.Keys.SITE_DROPDOWN] = [];
    initialState.rdx[Rdx.Keys.SPACETYPES_DROPDOWN] = [];
    initialState.rdx[Rdx.Keys.SPACETYPE_FILTERS] = [];
    initialState.rdx[Rdx.Keys.AREA_FILTERS] = [];
    initialState.rdx[Rdx.Keys.DEFAULT_AREA] = null;
    initialState.rdx[Rdx.Keys.BOOK_FILTERED_RESULTS] = [];
    initialState.rdx[Rdx.Keys.BOOK_FILTERED_RESULTS_NO_EMAIL] = [];
    initialState.rdx[Rdx.Keys.BOOK_SORT_SORTBY] = "name";
    initialState.rdx[Rdx.Keys.BOOK_SORT_SORTDIR] = "asc";
    initialState.rdx[Rdx.Keys.BOOK_WAS_SORT_INIT] = false;
    initialState.rdx[Rdx.Keys.SPACEPLANNER_ACTIVE_SECTION] = "plan";
    return initialState;
  }

  static getNextComponentId() {
    return "component_" + nextId++;
  }

  static getNextId() {
    return nextId++;
  }

  static getValue(state,key) {
    if (!state && Rdx.store) {
      state = Rdx.store.getState();
    }
    return Rdx.Selectors.getValue(state,"rdx",key);
  }

  static resetAll(store) {
    const action = Rdx.Actions.resetAll();
    if (!store) store = Rdx.store;
    store.dispatch(action);
  }

  static setValue(component,key,value) {
    const action = Rdx.Actions.setValue(key,value);
    if (!component && Rdx.store) {
      const dispatch = Rdx.store.dispatch;
      dispatch(action);
    } else {
      const dispatch = component.props.dispatch;
      dispatch(action);
    }
  }

}
